module.exports = __webpack_public_path__ + "img/cca-javascript-level-1.ba4c1bef.png";